<template>
  <div class="row">
    <div class="col-lg-8 col-lg-offset-2">
      <story-info :story="story"></story-info>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-8 col-lg-offset-2 chapter-nav">
      <button v-if="story.chapters > 1 && selected > 1" @click.prevent="chapterBack" class="btn btn-xs">&laquo; Previous</button>
      <select v-if="story.chapters > 1" v-model="selected" @change.prevent="changeChapter">
        <option v-for="cn in story.chapter_name" value="{{ $index + 1 }}">{{ cn }}</option>
      </select>
      <button v-if="story.chapters > 1 && selected < story.chapters" @click.prevent="chapterNext" class="btn btn-xs">Next &raquo;</button>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-8 col-lg-offset-2">
      <router-view></router-view>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-8 col-lg-offset-2 chapter-nav">
      <button v-if="story.chapters > 1 && selected > 1" @click.prevent="chapterBack" class="btn btn-xs">&laquo; Previous</button>
      <select v-if="story.chapters > 1" v-model="selected" @change.prevent="changeChapter">
        <option v-for="cn in story.chapter_name" value="{{ $index + 1 }}">{{ cn }}</option>
      </select>
      <button v-if="story.chapters > 1 && selected < story.chapters" @click.prevent="chapterNext" class="btn btn-xs">Next &raquo;</button>
    </div>
  </div>
  <div class="row">
  <div class="col-lg-8 col-lg-offset-2">
    <hr>
  </div>
</div>
</template>
<style>
  .chapter-nav {
    text-align: right;
  }
  .chapter-nav .btn {
    margin: 0 5px;
  }
</style>
<script language="text/babel">
  import StoryInfo from 'components/StoryInfo';
  export default {
    data() {
      return {
        story: {},
        selected: 0,
      };
    },
    components: {
      StoryInfo,
    },
    methods: {
      changeChapter() {
        this.$router.go({
          name: 'read-chapter',
          params: {
            story: this.$route.params.story,
            chapter: this.selected,
          },
        });
      },
      chapterBack() {
        this.selected--;
        this.changeChapter();
      },
      chapterNext() {
        this.selected++;
        this.changeChapter();
      },
    },
    route: {
      data({ next }) {
        const url = `static/archive/${this.$route.params.story}/story.json`;
        this.$http.get(url)
          .then((res) => { this.story = res.data; this.selected = this.$route.params.chapter; next(); });
      },
    },
  };
</script>



/** WEBPACK FOOTER **
 ** StoryView.vue?3e715bd3
 **/